/**
 * Helper function to get a cookie by name.
 * @param {String} name Name of the cookie to retrieve
 * @returns 
 */
export function getCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    return null;
}

/**
 * Helper function to set a cookie.
 * @param {String} name Name of the cookie to set
 * @param {*} value Vale of the cookie
 * @param {Int} days Expiry days of the cookie
 */
export function setCookie(name, value, days) {
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toGMTString();
    }
    document.cookie = name + '=' + value + expires + '; path=/; secure';
}

/**
 * Helper function to remove a cookie.
 * @param {*} name Name of the cookie to remove
 */
export function removeCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}